exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram3-5d-1{min-height:1320px}#diagram3-5d-1 .r2-block__box{margin-top:16px;height:133px!important}#diagram3-5d-1 .simplest__submit{bottom:-13px}#diagram3-5d-1 .bottom-box-list{display:flex;margin-bottom:-19px}#diagram3-5d-1 .bottom-box-list ul{list-style:none}#diagram3-5d-1 .bottom-box-list ul li{color:#fff}#diagram3-5d-1 .top-boxes .simplest__structure-framework__diagram-box{width:47%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/5/5d/diagram3/diagram3.scss
// module id = 1468
// module chunks = 0